import React from "react";
import { PlateoMascotIcon } from "./PlatypusMascot";

// Platypus mark for Plateo's AI job-applying agent.
// Renders the official mascot face (same SVG as PlateoMascotIcon).
// `light` is kept for call-site compatibility; the mascot palette is fixed.
function PlatypusLogo({ size = 22, light: _light = false, className = "" }) {
  return <PlateoMascotIcon size={size} className={`platypus-logo ${className}`.trim()} />;
}

export default PlatypusLogo;
